<template>
<div>
  <div class="banner">
    <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
  </div><br>
  <section>
    <div class="container">
    <h1 class="title">
        BP Workshop (สาขา {{ branchSelected }})
    </h1>
    </div>
  </section>
<div class="workshop">
  <div class="columns">
    <div class="column is-12" style="background-color:#fff;">
      รายการรถทั้งหมด: <b>{{totalitem}}</b> คัน, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      ขั้นตอน Body <b>{{totalitemBody}}</b> คัน, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      ขั้นตอน Paint <b>{{totalitemPaint}}</b> คัน
    </div>
  </div>
  <div class="columns">
    <div class="column is-12" style="background-color:#fff;">
      นัดส่ง :
      <span class="tag is-danger">ภายใน 2 วัน</span>
      <span class="tag is-warning">ภายใน 4 วัน</span>
      <span class="tag is-info">มากกว่า 4 วัน</span>
    </div>
  </div>

  <div class="columns colFixed" v-if="showMenu">
    <div class="column is-1 "><span class="menuFixed">รอคิวซ่อม</span></div>
    <div class="column is-1 "><span class="menuFixed">เคาะ</span></div>
    <div class="column is-1 "><span class="menuFixed">โป๊ว</span></div>
    <div class="column is-1 "><span class="menuFixed">พ่นสี</span></div>
    <div class="column is-1 "><span class="menuFixed">ประกอบ</span></div>
    <div class="column is-1 "><span class="menuFixed">ขัดสี</span></div>
    <div class="column is-1 "><span class="menuFixed">ตรวจสอบ</span></div>
    <div class="column is-1 "><span class="menuFixed">พร้อมส่ง</span></div>
  </div>

  <div class="columns">
    <div class="column is-1">
      <h3>รอคิวซ่อม ({{carList['queueWorkshop'].length}})</h3>
      <draggable class="list-group" tag="ul" v-model="carList['queueWorkshop']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group type="transition" id="queueWorkshop">
          <li class="list-group-item" v-for="element in carList['queueWorkshop']" :key="element.id">
            <card group="1" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['workshop_waitPart'].length}})</h3>
      <draggable element="span" v-model="carList['workshop_waitPart']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="workshop_waitPart">
          <li class="list-group-item" v-for="element in carList['workshop_waitPart']" :key="element.id">
            <card group="1" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รถไม่อยู่ ({{carList['workshop_waitCustomer'].length}})</h3>
      <draggable element="span" v-model="carList['workshop_waitCustomer']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="workshop_waitCustomer">
          <li class="list-group-item" v-for="element in carList['workshop_waitCustomer']" :key="element.id">
            <card group="1" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>รอเคาะ ({{carList['body1_queue'].length}})</h3>
      <draggable element="span" v-model="carList['body1_queue']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body1_queue">
          <li class="list-group-item" v-for="element in carList['body1_queue']" :key="element.id">
            <card group="2" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>เคาะ ({{carList['body1'].length}})</h3>
      <draggable element="span" v-model="carList['body1']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body1">
          <li class="list-group-item" v-for="element in carList['body1']" :key="element.id">
            <card group="2" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['body1_part'].length}})</h3>
      <draggable element="span" v-model="carList['body1_part']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body1_part">
          <li class="list-group-item" v-for="element in carList['body1_part']" :key="element.id">
            <card group="2" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>รอโป๊ว ({{carList['color1_queue'].length}})</h3>
      <draggable element="span" v-model="carList['color1_queue']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color1_queue">
          <li class="list-group-item" v-for="element in carList['color1_queue']" :key="element.id">
            <card group="3" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>โป๊ว ({{carList['color1'].length}})</h3>
      <draggable element="span" v-model="carList['color1']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color1">
          <li class="list-group-item" v-for="element in carList['color1']" :key="element.id">
            <card group="3" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['color1_part'].length}})</h3>
      <draggable element="span" v-model="carList['color1_part']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color1_part">
          <li class="list-group-item" v-for="element in carList['color1_part']" :key="element.id">
            <card group="3" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>รอพ่นสี ({{carList['color2_queue'].length}})</h3>
      <draggable element="span" v-model="carList['color2_queue']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color2_queue">
          <li class="list-group-item" v-for="element in carList['color2_queue']" :key="element.id">
            <card group="4" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>พ่นสี ({{carList['color2'].length}})</h3>
      <draggable element="span" v-model="carList['color2']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color2">
          <li class="list-group-item" v-for="element in carList['color2']" :key="element.id">
            <card group="4" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['color2_part'].length}})</h3>
      <draggable element="span" v-model="carList['color2_part']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color2_part">
          <li class="list-group-item" v-for="element in carList['color2_part']" :key="element.id">
            <card group="4" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>รอประกอบ ({{carList['body2_queue'].length}})</h3>
      <draggable element="span" v-model="carList['body2_queue']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body2_queue">
          <li class="list-group-item" v-for="element in carList['body2_queue']" :key="element.id">
            <card group="5" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>ประกอบ ({{carList['body2'].length}})</h3>
      <draggable element="span" v-model="carList['body2']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body2">
          <li class="list-group-item" v-for="element in carList['body2']" :key="element.id">
            <card group="5" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['body2_part'].length}})</h3>
      <draggable element="span" v-model="carList['body2_part']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="body2_part">
          <li class="list-group-item" v-for="element in carList['body2_part']" :key="element.id">
            <card group="5" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>รอขัดสี ({{carList['color3_queue'].length}})</h3>
      <draggable element="span" v-model="carList['color3_queue']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color3_queue">
          <li class="list-group-item" v-for="element in carList['color3_queue']" :key="element.id">
            <card group="6" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>ขัดสี ({{carList['color3'].length}})</h3>
      <draggable element="span" v-model="carList['color3']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color3">
          <li class="list-group-item" v-for="element in carList['color3']" :key="element.id">
            <card group="6" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>รออะไหล่ ({{carList['color3_part'].length}})</h3>
      <draggable element="span" v-model="carList['color3_part']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="color3_part">
          <li class="list-group-item" v-for="element in carList['color3_part']" :key="element.id">
            <card group="6" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>ตรวจสอบ ({{carList['final_inspec'].length}})</h3>
      <draggable element="span" v-model="carList['final_inspec']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="final_inspec">
          <li class="list-group-item" v-for="element in carList['final_inspec']" :key="element.id">
            <card group="7" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>

      <h3>ซ่อมร่วม GR ({{carList['joinGR'].length}})</h3>
      <draggable element="span" v-model="carList['joinGR']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="joinGR">
          <li class="list-group-item" v-for="element in carList['joinGR']" :key="element.id">
            <card group="9" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>

    <div class="column is-1">
      <h3>พร้อมส่ง ({{carList['finish'].length}})</h3>
      <draggable element="span" v-model="carList['finish']" v-bind="dragOptions" :move="onMove" @end="onEnd">
        <transition-group class="list-group" tag="ul" id="finish">
          <li class="list-group-item" v-for="element in carList['finish']" :key="element.id">
            <card group="8" :item="element" :profile="profile"></card>
          </li>
        </transition-group>
      </draggable>
    </div>
  </div>
</div>

<div :class="'modal '+ modal_open" id="modal_technician">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">กรุณาเลือกช่าง</p>
    </header>
    <section class="modal-card-body">
      <div class="container">
            ช่างคนที่ 1
          <div class="select">
              <select v-model="staffId">
                <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
              </select>
          </div><br><br><br>
          ช่างคนที่ 2
          <div class="select">
              <select v-model="staffId_2">
                <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
              </select>
          </div><br><br><br>
          ช่างคนที่ 3
          <div class="select">
              <select v-model="staffId_3">
                <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
              </select>
          </div><br><br><br>
          ช่างคนที่ 4
          <div class="select">
              <select v-model="staffId_4">
                <option v-for="staff in staffList.technician" v-bind:key="staff.code" :value="staff.code" >{{staff.name}}</option>
              </select>
          </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" v-on:click="updateTechnician">บันทึก</button>
    </footer>
  </div>
</div>
</div>
</template>

<script>
import draggable from 'vuedraggable'
import card from './card.vue'

export default {
  name: 'hello',
  components: {
    draggable,
    'card': card
  },
  data: () => ({
    estimatePosition: ['General Manager', 'Estimator Controller', 'Estimator', 'Administration Estimator'],
    showMenu: false,
    modal_open: '',
    btn_confirm_title: 'บันทึก',
    selectTechnician: false,
    staffId: null,
    staffId_2: null,
    staffId_3: null,
    staffId_4: null,
    branchCode: '',
    updatedBy: null,
    branch: [],
    jobTypeList: [
      { 'code': 'Q', 'name': 'Q' },
      { 'code': 'M', 'name': 'M' },
      { 'code': 'H', 'name': 'H' },
      { 'code': 'Super Quick', 'name': 'Super Quick' }
    ],
    dataAlready: {
      'queueWorkshop': false,
      'workshop_waitPart': false,
      'workshop_waitCustomer': false,
      'body1_queue': false,
      'body1': false,
      'body1_part': false,
      'body2_queue': false,
      'body2': false,
      'body2_part': false,
      'color1_queue': false,
      'color1': false,
      'color1_part': false,
      'color2_queue': false,
      'color2': false,
      'color2_part': false,
      'color3_queue': false,
      'color3': false,
      'color3_part': false,
      'joinGR': false,
      'final_inspec': false,
      'finish': false
    },
    carId: '',
    carList: {
      'queueWorkshop': [],
      'workshop_waitPart': [],
      'workshop_waitCustomer': [],
      'body1_queue': [],
      'body1': [],
      'body1_part': [],
      'body2_queue': [],
      'body2': [],
      'body2_part': [],
      'color1_queue': [],
      'color1': [],
      'color1_part': [],
      'color2_queue': [],
      'color2': [],
      'color2_part': [],
      'color3_queue': [],
      'color3': [],
      'color3_part': [],
      'joinGR': [],
      'final_inspec': [],
      'finish': []
    },
    caption: {
      'queueWorkshop': 'รอคิวซ่อม',
      'workshop_waitPart': 'รออะไหล่',
      'workshop_waitCustomer': 'รถไม่อยู่',
      'body1_queue': 'รอเคาะ',
      'body1': 'เคาะ',
      'body1_part': 'เคาะ (รออะไหล่)',
      'body2_queue': 'รอประกอบ',
      'body2': 'ประกอบ',
      'body2_part': 'ประกอบ (รออะไหล่)',
      'color1_queue': 'รอโป๊ว',
      'color1': 'โป๊ว',
      'color1_part': 'โป๊ว (รออะไหล่)',
      'color2_queue': 'รอพ่นสี',
      'color2': 'พ่นสี',
      'color2_part': 'พ่นสี (รออะไหล่)',
      'color3_queue': 'รอขัดสี',
      'color3': 'ขัดสี',
      'color3_part': 'ขัดสี (รออะไหล่)',
      'joinGR': 'ซ่อมร่วม GR',
      'final_inspec': 'ตรวจสอบ',
      'finish': 'พร้อมส่ง'
    },
    staffList: {
      'technician': [],
      'leader': []
    },
    totalitem: 0,
    totalitemBody: 0,
    totalitemPaint: 0,
    editable: true,
    isDragging: false,
    delayedDragging: false,
    target: null,
    fromId: null,
    toId: null,
    branchSelected: null,
    profile: null
  }),
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  async mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    this.updatedBy = this.$session.get('vgroup')
    console.log(this.updatedBy)
    this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    this.branchCode = params.get('branchCode')
    this.branch.map((item) => {
      this.branchSelected = (item.id === this.branchCode) ? item.name : this.branchSelected
      return true
    })
    await this.getProfile()
    this.getTechnician()
    this.getList()
    this.autoReload()
    this.calTotalItem()
  },
  methods: {
    handleScroll (event) {
      if (event.path[1].scrollY >= 250) {
        this.showMenu = true
      } else {
        this.showMenu = false
      }
    },
    async getProfile () {
      await this.$axios
        .get(`${this.$apiUrl}getStaffById?code=${this.updatedBy}`)
        .then(response => {
          if (response.data.length > 0) {
            this.profile = response.data[0]
          }
        })
    },
    getList () {
      this.getCarList('queueWorkshop')
      this.getCarList('workshop_waitPart')
      this.getCarList('workshop_waitCustomer')
      this.getCarList('body1_queue')
      this.getCarList('body1')
      this.getCarList('body1_part')
      this.getCarList('body2_queue')
      this.getCarList('body2')
      this.getCarList('body2_part')
      this.getCarList('color1_queue')
      this.getCarList('color1')
      this.getCarList('color1_part')
      this.getCarList('color2_queue')
      this.getCarList('color2')
      this.getCarList('color2_part')
      this.getCarList('color3_queue')
      this.getCarList('color3')
      this.getCarList('color3_part')
      this.getCarList('joinGR')
      this.getCarList('final_inspec')
      this.getCarList('finish')
    },
    autoReload () {
      let _this = this
      _this.t = setInterval(() => {
        this.getList()
      }, 120 * 1000)
    },
    stopReload () {
      clearInterval(this.t)
    },
    async getTechnician () {
      let _this = this
      await this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=B/P Technician (PT)`)
        .then(response => {
          _this.staffList['technician'] = response.data
        })
      await this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=B/P Technician (BT)`)
        .then(response => {
          this.staffList['technician'] = _this.staffList['technician'].concat(response.data)
        })
      await this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=B/P Controller`)
        .then(response => {
          this.staffList['technician'] = _this.staffList['technician'].concat(response.data)
        })
      await this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=B/P Technician Leader (BT)`)
        .then(response => {
          this.staffList['technician'] = _this.staffList['technician'].concat(response.data)
        })
      await this.$axios
        .get(`${this.$apiUrl}getStaffList?branch=${_this.branchCode}&position=B/P Technician Leader (PT)`)
        .then(response => {
          this.staffList['technician'] = _this.staffList['technician'].concat(response.data)
        })
    },
    getCarList (step) {
      let _this = this
      _this.dataAlready[step] = false
      this.$axios
        .get(`${this.$apiUrl}getCarProgressBP?current=${step}&branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready[step] = true
          _this.carList[step] = response.data
        })
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      this.target = draggedElement
      this.staffId = null
      this.staffId_2 = null
      this.staffId_3 = null
      this.staffId_4 = null
      this.calTotalItem()
      this.stopReload()
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    calTotalItem () {
      this.totalitemBody = (this.carList['joinGR'].length + this.carList['body1_queue'].length + this.carList['body1'].length + this.carList['body1_part'].length + this.carList['body2_queue'].length + this.carList['body2'].length + this.carList['body2_part'].length)
      this.totalitemPaint = (this.carList['color1_queue'].length + this.carList['color1'].length + this.carList['color1_part'].length + this.carList['color2_queue'].length + this.carList['color2'].length + this.carList['color2_part'].length + this.carList['color3_queue'].length + this.carList['color3'].length + this.carList['color3_part'].length)
      this.totalitem = (this.carList['queueWorkshop'].length + this.carList['workshop_waitPart'].length + this.carList['workshop_waitCustomer'].length + this.totalitemBody + this.totalitemPaint + this.carList['final_inspec'].length + this.carList['finish'].length)
    },
    async onEnd (/** Event */ evt) {
      this.fromId = evt.from.id
      this.toId = evt.to.id
      if (this.toId === 'body1' || this.toId === 'body2' || this.toId === 'color1' || this.toId === 'color2' || this.toId === 'color3') {
        this.modal_open = 'is-active'
      }
      await this.updateProgress()
    },
    async updateTechnician () {
      this.modal_open = ''
      this.stopReload()
      let params = {
        car: this.target,
        carId: this.target.id,
        current: this.fromId,
        nextStep: this.toId,
        staffId: this.staffId,
        staffId_2: this.staffId_2,
        staffId_3: this.staffId_3,
        staffId_4: this.staffId_4
      }
      await this.$axios
        .post(`${this.$apiUrl}updateProgressBP`, params)
        .then(response => {
          this.updateSuccess = true
          this.getList()
          this.autoReload()
        })
    },
    async updateProgress () {
      this.stopReload()
      let params = {
        car: this.target,
        carId: this.target.id,
        current: this.fromId,
        nextStep: this.toId,
        staffId: null,
        staffId_2: null,
        staffId_3: null,
        staffId_4: null
      }
      await this.$axios
        .post(`${this.$apiUrl}updateProgressBP`, params)
        .then(response => {
          this.updateSuccess = true
          this.getList()
          this.autoReload()
        })
    }
  },
  computed: {
    dragOptions () {
      this.calTotalItem()
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    },
    listString () {
      return JSON.stringify(this.list, null, 2)
    },
    list2String () {
      return JSON.stringify(this.list2, null, 2)
    }
  },
  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  }
}
</script>

<style scoped>
.colFixed {
  position: fixed;
  top: 10px;
  z-index: 9;
  width: 100%;
}
.colFixed > div.column {
  margin: 2px;
  background-color: #ccc !important;
}
.menuFixed {
  font-size: 16px;
  font-weight: bold;
}
.banner {
  text-align: center;
  background-color: #000;
}
.workshop {
  padding: 5px 20px !important;
}
h3 {
  font-size: 18px;
  font-weight: bold;
}
.container {
  margin: 0 auto;
}
.column {
  margin: 3px;
  background-color: #eee;
}
.is-1 {
  width: 12.1%;
}
.item-queue {
  float: left;
  width: 45%;
  margin-left: 10px;
}
.item-wait {
  float: left;
  width: 30%;
  margin-left: 10px;
}
.flip-list-move {
  transition: transform .5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  background: #c8ebfb;
  opacity: .5;
}
.list-group {
  min-height: 150px;
  padding-bottom: 20px;
  background-color: #eee;
}
.list-group-item {
  height: 85px;
  padding: 8px;
  padding-top: 15px;
  margin-top: 5px;
  background-color: #ccc;
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BP/workshop.vue